/**
 * 全ページ共通エントリースクリプト
 *
 * - ページごとに個別JSを自動実行
 * - 共通初期化処理（initCommon）も必ず実行
 *
 * @example
 *   // HTMLで読み込むだけでOK
 *
 * 注意:
 * - ページ名とpageMapのキーが一致している必要あり
 * - ルートやinterview系は特別処理で分岐
 */
import { initCommon } from './common/script.js';

// ✅ ページ別
import indexJ from './pages/index_j.js';
import interview from './pages/interview.js';
// import about from "./pages/about.js";

// ✅ 読み込むページの mapping
const pageMap = {
	'index_j.html': indexJ,
	'': indexJ, // ← ✅ ルートでも同じJSを使う
	'interview.html': interview,
	// 'about.html': about,
};

// =====================================
// ✅ 実行
// =====================================
document.addEventListener('DOMContentLoaded', () => {
	// 共通初期化処理
	// ✅ 共通処理
	initCommon();

	// 現在のページ名を取得
	// ✅ 現在のページ名を取得
	let file = location.pathname.split('/').pop();

	// ルートやinterviewページの特別処理
	// ✅ ルートパス（例: http://localhost:3000/）のとき
	if (file === '' || file === '/') {
		file = 'index_j.html';
	} else if (file.includes('interview')) {
		file = 'interview.html';
	}

	// ページ固有JSの実行
	// ✅ ページ固有JS実行
	if (pageMap[file]) {
		pageMap[file]();
	}
});
